var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoHealthcareInstituteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 60,
    height: 45,
    rx: 5,
    stroke: "currentColor",
    strokeWidth: 8,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 30 V20 H60 V30",
    stroke: "currentColor",
    strokeWidth: 8,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 42 V62 M40 52 H60",
    stroke: "currentColor",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoHealthcareInstituteLogo);
export default __webpack_public_path__ + "static/media/demo-healthcare-institute-logo.8517fba606b2c42b75453f740f6a788e.svg";
export { ForwardRef as ReactComponent };